export default (state = [], action) => {
    switch (action.type) {
        case 'FETCH_PORTAL_APPS':
            return action.payload;
         default:
             return state;
    }
};